<template>
  <v-container>
    <v-row no-gutters class="mt-3" v-if="!isPartner">
      <v-col cols="12" sm="7" class="d-flex">
        <div class="pr-3 pt-2">
          <material-category-card @created="setLastCategory()"></material-category-card>
        </div>
        <v-autocomplete
          label="Категория материалов"
          v-model="category"
          :items="categories"
          item-text="name"
          item-value="_id"
          filled
          prepend-icon
        ></v-autocomplete>
        <div class="pt-2 pl-3">
          <material-category-card v-if="category" :id="category" :key="category"></material-category-card>
          <delete-button
            v-if="category"
            :id="category"
            :deleteFunc="deleteCategory"
            objName="категорию"
          >
            Все материалы в данной категории будут удалены.
          </delete-button>
        </div>
        <v-spacer></v-spacer>
        
      </v-col>
      <v-col cols="12" sm="5" class="pt-2 pl-3 d-flex">
        <v-spacer></v-spacer>
        <v-dialog 
          v-model="activeBrandModal"  
          max-width="400"
          @click:outside="activeBrandModal = false;"
          :fullscreen="$vuetify.breakpoint.smAndDown"
        >
          <template v-slot:activator="{ on }">
            <a href="#" v-on="on">
              Производители
            </a>
          </template>

          <v-card>
            <v-toolbar
              color="primary"
              dark
              flat
            >
              <v-toolbar-title>Производители материалов</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon @click="activeBrandModal = false;">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>

            <v-card-text class="mt-7">
              <div
                v-for="item of brands"
                :key="item.name"
              >
                {{ item.index }}. {{ item.name }}
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>

    <v-data-table
      class="elevation-1"
      :headers="tableHeaders"
      :items="materials"
      :search="search"
      :key="categoryKey"
      :disable-pagination="isPartner"
      :hide-default-footer="isPartner"
    >
      <template v-slot:top>
        <v-row class="ma-0 pa-0 ml-2 mr-2">
          <v-col cols="10" sm="8">
            <v-text-field
              placeholder="Введите данные для поиска"
              v-model="search"
            ></v-text-field>
          </v-col>
          <v-col cols="2" sm="4" class="d-flex pt-5" v-if="!isPartner">
            <v-spacer></v-spacer>
            <material-card :category="category"></material-card>
          </v-col>
        </v-row>
      </template>

      <template v-slot:[`item.updown`]="{ item }">
        <up-down-elem
          :id="item._id"
          upFunc="prices/UP_MATERIAL"
          downFunc="prices/DOWN_MATERIAL"
          :key="item._id"
        ></up-down-elem>
      </template>

      <template v-slot:[`item.pricePerUnit`]="{ item }">
        <number-field
          :value="item.pricePerUnit"
          :accuracy="2"
          @changed="$store.commit('prices/UPDATE_MATERIAL_PRICE', { id: item._id, newPrice: $event })"
        ></number-field>
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <material-card :id="item._id" :key="item._id"></material-card>

        <delete-button
          :id="item._id"
          :deleteFunc="deleteMaterial"
          objName="материал"
        >
          Название: {{ item.name }}
        </delete-button>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import MaterialCategoryCard from './MaterialCategoryCard';
import MaterialCard from './MaterialCard';

export default {
  name: 'materials',

  components: {
    MaterialCategoryCard,
    MaterialCard
  },

  data() {
    return {
      category: null,
      search: '',
      activeBrandModal: false,
    }
  },

  methods: {
    async deleteCategory(id) {
      this.$store.commit('prices/DELETE_MATERIAL_CATEGORY', id);
      this.category = null;
      return { message: 'Категория успешно удалена.' }
    },
    setLastCategory() {
      this.category = this.categories[this.categories.length - 1]._id;
    },
    async deleteMaterial(id) {
      this.$store.commit('prices/DELETE_MATERIAL', id);
      return { message: 'Материал успешно удален.' }
    }
  },

  computed: {
    ...mapGetters('prices', ['materialCategories']),
    ...mapGetters('users', ['isPartner']),
    categories() {
      return [
        {
          _id: null,
          name: '-- НЕ ВЫБРАНА --'
        },
        ...this.$store.getters['prices/materialCategories'].map(elem => {
          if (elem.unitName) return { _id: elem._id, name: `${elem.name} (${elem.unitName})` }
          else return elem;
        })
      ]; 
    },
    categoryKey() {
      if (this.category) {
        let categoryObj = this.materialCategories.find(x => x._id == this.category);
        return this.category + categoryObj.unitName;
      } else {
        return 1;
      }
    },
    materials() {
      let items = this.$store.getters['prices/materials'];
      if (this.category) items = items.filter(x => x.category == this.category);
      if (this.isPartner) {
        // Выбираем только те материалы, которые используются по умолчанию в Работах
        let services = this.$store.getters['prices/services'];
        for (let serv of services) {
          for (let mt of serv.materials) {
            if (!mt.isCategory) {
              let mItem = items.find(x => x._id == mt._id);
              if (mItem) mItem._marked = true;
            }
          }
        }
        items = items.filter(x => x._marked);
      } 
      return items.map((x, index) => ({
        ...x,
        index
      }));
    },
    brands() {
      let brands = Array.from(new Set(this.$store.getters['prices/materials'].map(x => x.brand))).filter(x => Boolean(x));
      brands.sort();
      return brands.map((x, index) => ({
        name: x,
        index
      }));
    },
    tableHeaders() {
      let headers = [];
      if (this.category) {
        headers.push({
          text: '',
          value: 'updown'
        });
      }
      headers.push(
        {
          text: '№',
          value: 'index'
        }
      );
      if (!this.category) {
        headers.push({
          text: 'Категория',
          value: 'categoryName'
        });
      }
      headers.push(
        {
          text: 'Наименование',
          value: 'name'
        },
        {
          text: 'Ед. изм.',
          value: 'units'
        },
        {
          text: 'Цена за ед.',
          value: 'pricePerUnit'
        }
      );
      if (!this.$store.getters['users/isPartner']) {
        headers.push({
          text: 'Действия',
          value: 'actions'
        });
      }
      return headers;
    }
  }
}
</script>